const GoogleFlightFront = ({ smartixPassType, passType, subType, classData, passData }) => {
  return (

    <div className="inset flight">
      <div>Flight (Boarding Pass)</div>
    </div>
  )
}

export default GoogleFlightFront